<!-- 集采平台订单 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-body custom-class="drawer_box" direction="ltr" size="100%">
            <orderpoolQueryDetail v-if="showStatus" ref="orderpoolQueryDetail" @drawerCancel="drawerCancel" :actionData="actionData"></orderpoolQueryDetail>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" class="table1" stripe :data="returnData.list" :height="(tableHeight / 2) + 50" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini"
                @selection-change="handleSelectionChange" @current-change="handleCurrentChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                    scope.row[tableValye.entityField] }}</a>
                            </span>
                            <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}
                            </el-tag>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="page_content_bottom">
                <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
            </div>
            <el-table v-if="detailTableColumns.length > 0" class="table1" stripe :data="returnData.detailsList" :height="(tableHeight / 2) - 50" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="bindBgmDetail(scope.row)">
                            绑定商品
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column align="center" v-for="(tableValye, tableKey) in detailTableColumns" :key="'detail_' + tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField"
                    :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.fieldType == 'number'">
                            {{ scope.row[tableValye.entityField] || 0 }}
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                        </span>
                        <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}
                        </el-tag>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" append-to-body>
            <div class="bgmObj" v-if="bgmShow">
                <p v-if="bgmCodeObj.bgmName">
                    <span>通用名称:</span>
                    <span>{{ bgmCodeObj.bgmName }}</span>
                </p>
                <p v-if="bgmCodeObj.bgiGename">
                    <span>商品名称:</span>
                    <span>{{ bgmCodeObj.bgiGename }}</span>
                </p>
                <p v-if="bgmCodeObj.bgmCode">
                    <span>ERP商品编码:</span>
                    <span>{{ bgmCodeObj.bgmCode }}</span>
                </p>
                <p v-if="bgmCodeObj.spId">
                    <span>平台编码:</span>
                    <span>{{ bgmCodeObj.spId }}</span>
                </p>
                <p v-if="bgmCodeObj.spec">
                    <span>规格:</span>
                    <span>{{ bgmCodeObj.spec }}</span>
                </p>
                <p v-if="bgmCodeObj.manufacturer">
                    <span>生产商:</span>
                    <span>{{ bgmCodeObj.manufacturer }}</span>
                </p>
                <p v-if="bgmCodeObj.bgiAppnumber">
                    <span>批准文号:</span>
                    <span>{{ bgmCodeObj.bgiAppnumber }}</span>
                </p>
            </div>
            <div class="bgmObj" v-if="cmShow">
                <p v-if="cmCodeObj.unitName">
                    <span>单位名称:</span>
                    <span>{{ cmCodeObj.unitName }}</span>
                </p>
                <p v-if="cmCodeObj.platcmId">
                    <span>平台单位编号:</span>
                    <span>{{ cmCodeObj.platcmId }}</span>
                </p>
                <p v-if="cmCodeObj.unitCode">
                    <span>ERP单位编号:</span>
                    <span>{{ cmCodeObj.unitCode }}</span>
                </p>
            </div>
            <SearchScheme :oneFlag="oneFlag" ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import orderpoolQueryDetail from "@/components/orderpoolQueryDetail.vue";
export default {
    components: { SearchScheme, orderpoolQueryDetail },
    data() {
        return {
            tableHeight: 0,
            getRequestData: {
                unitName: "",
                businessId: "",
                orderState: "",
                page: 1,
                rows: 30,
                start: '',
                end: '',
            },
            returnData: {
                pages: 0,
                total: 0,
                pageNum: 0,
                list: [],
                detailsList: []
            },
            sField: '',
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            seTitle: "",
            DialogVisible: false,
            seWidth: '0',
            seId: 0,
            smId: 0,
            showStatus: false,
            actionData: {},
            parentSearchData: {},
            multipleSelection: [],
            bgmShow: false,
            cmShow: false,
            oneFlag: false,
            bgmInfo: {
                bgmName: '',
                bgmId: '',
            },
            bgmCodeObj: {
                bgmName: '',
                bgiGename: '',
                bgmCode: '',
                spec: '',
                manufacturer: '',
                bgiAppnumber: '',
                spId: "",
            },
            cmCodeObj: {
                platcmId: "",
                unitName: '',
                unitCode: '',
            },
            info: {
                cmName: '',
                cmId: '',
                poolId: '',
            },
            currentDetailRow: null,
        };
    },
    computed: {
        detailTableColumns() {
            if (this.pageShowData && this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.length > 0) {
                const detailForm = this.pageShowData.jurFormVoList[0];
                if (detailForm && detailForm.jurconfigform) {
                    return detailForm.jurconfigform.filter(item => item.isShow == 1);
                }
            }
            return [];
        }
    },
    watch: {
        'getRequestData.smName': {
            handler: function (newValue) {
                if (newValue == '') {
                    this.getRequestData.smId = ''
                }
            },
            deep: true,
        }
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val
            if (val && val.length > 0) {
                this.getSelectedRowsDetails(val);
            } else {
                this.returnData.detailsList = [];
            }
        },
        handleCurrentChange(currentRow) {
            if (!currentRow) {
                this.returnData.detailsList = [];
            }
        },
        async getSelectedRowsDetails(selectedRows) {
            try {
                const orderIds = selectedRows.map(row => row.orderId).filter(id => id);
                if (orderIds.length === 0) {
                    this.returnData.detailsList = [];
                    return;
                }
                const params = {
                    ids: orderIds
                };
                const response = await this.$http.orderpoolqueryJcDetail(params);
                if (response && response.status === 200) {
                    this.returnData.detailsList = response.result.list || response.result || [];
                } else {
                    this.$message.error('获取明细数据失败: ' + (response.message || '未知错误'));
                    this.returnData.detailsList = [];
                }
            } catch (error) {
                console.error('获取选中行明细数据失败:', error);
                this.$message.error('获取明细数据失败');
                this.returnData.detailsList = [];
            }
        },
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        bindBgmDetail(row) {
            this.currentDetailRow = row;
            this.bgmInfo.bgmName = '';
            this.bgmInfo.bgmId = '';
            this.bgmCodeObj = {
                bgmName: row.bgmName || row.goodsName || '',
                bgiGename: row.bgiGename || row.goodsName || '',
                spId: row.spId || '',
                bgmCode: row.bgmCode || row.goodsCode || '',
                spec: row.spec || '',
                manufacturer: row.manufacturer || '',
                bgiAppnumber: row.bgiAppnumber || row.appNumber || '',
            };
            this.openSearch1('8820873997127718', 0, 'bgmName', 'bgmName,bgmId')
        },
        clearBgmInfo() {
            this.bgmInfo.bgmName = '';
            this.bgmInfo.bgmId = '';
        },
        async sureSubmitBgm() {
            if (!this.bgmInfo.bgmId || !this.bgmInfo.bgmName) {
                this.$message.warning('请选择要绑定的商品');
                return;
            }
            try {
                const params = {
                    poolDetailId: this.currentDetailRow.pooldetailId,
                    bgmId: this.bgmInfo.bgmId,
                };
                const responseData = await this.$http.orderpoolbindJcCode(params);
                if (responseData.status == 200) {
                    this.$message.success(responseData.message || '绑定商品成功');
                    if (this.multipleSelection.length > 0) {
                        this.getSelectedRowsDetails(this.multipleSelection);
                    }
                } else {
                    this.$message.error(responseData.message || '绑定商品失败');
                }
            } catch (error) {
                console.error('绑定商品失败:', error);
                this.$message.error('绑定商品失败');
            }
        },
        toDetail(orderId) {
            if (orderId) {
                var isPenetrate = true
                sessionStorage.setItem('penetrateOrderId', orderId);
                window.parent.postMessage({
                    cmd: 'returnFormJson',
                    params: { isPenetrate }
                }, '*');
            }
        },
        openSearch({ sId, index, type, sField }) {
            this.bgmShow = false
            this.cmShow = false
            this.oneFlag = false
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        openSearch1(sId, index, type, sField) {
            this.bgmShow = false
            this.cmShow = false
            this.oneFlag = false
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            if (type == 'bgmName') {
                this.bgmShow = true
                this.oneFlag = true
                this.parentSearchData[type] = this.bgmCodeObj.bgmName
            } else if (type == 'cmName') {
                this.cmShow = true
                this.oneFlag = true
                this.parentSearchData[type] = this.cmCodeObj.unitName
            } else {
                this.parentSearchData[type] = this.info[type]
            }
        },
        changeInputModel(val) {
            if (val && val != "") {
                this.DialogVisible = false;
                if (this.seId == '8820873997127718') {
                    this.bgmInfo.bgmId = val.bgmId
                    this.bgmInfo.bgmName = val.bgmName
                    this.sureSubmitBgm()
                } else if (this.seId == '3391151360249856') {
                    this.info.cmId = val.cmId
                    this.info.cmName = val.cmName
                    this.sureSubmitsm()
                } else {
                    this.paramValue(val)
                }
            }
        },
        async sureSubmitsm() {
            if (!this.info.cmId || !this.info.cmName) {
                this.$message.warning('请选择要绑定的客户');
                return;
            }
            try {
                const responseData = await this.$http.orderpoolbindJcUnitCode(this.info)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message || '绑定客户成功')
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message || '绑定客户失败')
                }
            } catch (error) {
                console.error('绑定客户失败:', error);
                this.$message.error('绑定客户失败');
            }
        },
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        isShowData(name, value) {
            switch (name) {
                case 'customerList':
                    var dataInfo = sessionStorage.getItem('selectCustomerData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.smId = dataInfo.smId
                        this.getRequestData.smName = dataInfo.smName
                    }
                    break;
                default:
                    this.getRequestData[name] = value
            }
        },
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.getButtonList()
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurFormVoList[0].jurconfigform
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: '请先选中一条要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.multipleSelection[0]
                    this.showStatus = true
                    this.actionData = {
                        cate: 2, formData: this.pageShowData.jurTableVo,
                        oldData: dataInfo, orderId: dataInfo.orderId, printSouce: '',
                        printJurId: '', type: 'one'
                    }
                    break;
                case 1:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: '请先选中一条要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var editInfo = this.multipleSelection[0]
                    this.showStatus = true
                    this.actionData = {
                        cate: 1, formData: this.pageShowData.jurTableVo,
                        oldData: editInfo, orderId: editInfo.orderId, printSouce: '',
                        printJurId: '', type: 'one'
                    }
                    break;
                case 2:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.del()
                    break;
                case 7:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    if (this.multipleSelection.length != 1) {
                        this.$message({
                            message: '请先选中一条要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    var bindInfo = this.multipleSelection[0]
                    if (bindInfo.orderState != 0 && bindInfo.orderState != -1) {
                        return this.$message({
                            message: '该状态不允许修改绑定单位',
                            type: 'error'
                        });
                    }
                    this.info.cmId = ''
                    this.info.cmName = ''
                    this.info.poolId = bindInfo.poolId
                    this.cmCodeObj = {
                        unitName: bindInfo.unitName || '',
                        unitCode: bindInfo.unitCode || '',
                        platcmId: bindInfo.platcmId || '',
                    }
                    this.openSearch1('3391151360249856', 0, 'cmName', 'cmName,cmId')
                    break;
                case 5://重置
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.jcResetInit()
                    break;
                case 6://重置上传入库码
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.resetRkm()
                    break;
                case 8://重置上传随货
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.resetOut()
                    break;
                case 9://差量发货
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.diffShip()
                    break;
            }
        },
        diffShip() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            if (this.multipleSelection.some(item => item.orderState != 2)) {
                return this.$message({
                    message: '该状态不允许进行差量发货',
                    type: 'error'
                });
            }
            this.$confirm('确定要差量发货吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "info"
            }).then(async () => {
                const params = {
                    ids: this.multipleSelection.map(item => item.orderId),
                }
                const responseData = await this.$http.diffShip(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        jcResetInit() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中一条要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('确定要重置吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "info"
            }).then(async () => {
                const params = {
                    ids: this.multipleSelection.map(item => item.orderId),
                }
                const responseData = await this.$http.jcResetInit(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        resetRkm() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('确定要重置上传入库码吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "info"
            }).then(async () => {
                const params = {
                    ids: this.multipleSelection.map(item => item.orderId),
                }
                const responseData = await this.$http.resetRkm(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        resetOut() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('确定要重置上传随货吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "info"
            }).then(async () => {
                const params = {
                    ids: this.multipleSelection.map(item => item.orderId),
                }
                const responseData = await this.$http.resetOut(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        del() {
            if (this.multipleSelection.length != 1) {
                this.$message({
                    message: '请先选中一条要操作的数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.multipleSelection[0]
            this.$confirm('确定要作废该数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: "error"
            }).then(async () => {
                const params = {
                    ids: [dataInfo.orderId],
                }
                const responseData = await this.$http.orderpoolinvalid(params)
                if (responseData.status == 200) {
                    this.$message.success(responseData.message)
                    this.getDataList()
                } else {
                    this.$message.error(responseData.message)
                }
            })
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        searchData() {
            this.getRequestData.page = 1
            this.returnData.detailsList = []
            this.getDataList()
        },
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.returnData.detailsList = []
            this.getDataList()
        },
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.returnData.detailsList = []
            this.getDataList()
        },
        async getDataList() {
            let responseData = await this.$http.orderpoolqueryJcOrder(this.getRequestData)
            if (responseData && responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData))
                this.returnData.list = resData.result.list
                this.returnData.pages = resData.result.pages
                this.returnData.total = resData.result.total
                this.returnData.pageNum = resData.result.pageNum
                this.selectedDataIndex = 0
                this.returnData.detailsList = []
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        initTime() {
            this.getRequestData.start = this.$common.getStartTime()
            this.getRequestData.end = this.$common.getEndTime()
        },
    },
    created() {
        this.getPageInfo()
        this.initTime()
    },
    mounted() { },
    beforeCreate() { },
    beforeMount() { },
    beforeUpdate() { },
    updated() { this.tableHeight = this.$common.getTableHeight() },
    beforeDestroy() { },
    destroyed() { },
    activated() { },
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.bgmObj {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.bgmObj p {
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 16px;
}

.bgmObj p span:nth-child(1) {
    margin-right: 5px;
    color: #000;
    font-weight: bold;
}

.bgmObj p span:nth-child(2) {
    color: red;
}
</style>
